import { AxiosError } from "axios";
import { ScheduleWorkingHoursViolation } from "@myapp/contract";

/**
 * The third flavour of 409 on the scheduling routes, after SCHEDULE_CONFLICT and
 * SCHEDULE_COMPLETED_BLOCKERS. Nothing is in the way here — the technician simply does not work
 * then — so the override is `allowOutsideWorkingHours`, never `force`.
 */
export function parseWorkingHoursViolationsFromError(
  error: unknown,
): ScheduleWorkingHoursViolation[] | null {
  if (!(error instanceof AxiosError)) return null;
  if (error.response?.status !== 409) return null;
  const data = error.response.data as { error?: string; data?: unknown };
  if (data?.error !== "SCHEDULE_OUTSIDE_WORKING_HOURS") return null;
  if (!Array.isArray(data?.data)) return null;
  return data.data as ScheduleWorkingHoursViolation[];
}
